<div class="dialog">
    <h2 class="dialog__title">Rename Trip</h2>

    <input type="text" class="dialog__input" placeholder="Type new name" [formControl]="tripNameControl"/>

    <div class="dialog__actions">
        <button mat-ripple class="dialog__button dialog__button--cancel" (click)="closeModal(false)">
            Cancel
        </button>
        <button mat-ripple class="dialog__button dialog__button--confirm"
                (click)="closeModal(tripNameControl.getRawValue())"
                [disabled]="tripNameControl.invalid">
            Change name
        </button>
    </div>
</div>
